// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"dea07882cacf9fe9","5210":"26c06afa196b3198","5371":"d18b7833f6d2cae9","9923":"53e2a3b31477ca62"}[chunkId] + ".css";
};